import { useState } from "react";
import Modal from "../../../modal";
import styles from "./styles.module.css";
import { MdClose, MdArrowDropDown } from "react-icons/md";
import useUtilities from "../../../utils/useutilities";
import { makeid } from "../../../utils/pageactions";

export default function AddUtiltiy({ open, onClose, onSelect }) {
  const utilities = useUtilities();
  const handleSelect = (u) => {
    const _props = {};
    u.props.forEach((prop) => {
      if (
        prop.editorParams &&
        (prop.editorParams.default || prop.editorParams.default === false)
      ) {
        _props[prop.name] = prop.editorParams.default;
      }
    });
    onSelect({
      name: u.name,
      displayName: "new " + u.displayName,
      props: _props,
      id: makeid(16),
    });
  };
  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.addUtility}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0px 15px 15px 15px",
          }}
        >
          <div style={{ fontSize: 20 }} className={styles.title}>
            Add Utility
          </div>
          <MdClose className={styles.close} onClick={onClose} />
        </div>
        {utilities.map((u) => {
          return (
            <AddItem
              onSelect={() => handleSelect(u)}
              key={u.name}
              utility={u}
            />
          );
        })}
      </div>
    </Modal>
  );
}

const AddItem = ({ utility, onSelect }) => {
  const [open, setOpen] = useState(false);

  const handleToggle = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };
  return (
    <div onClick={onSelect} className={styles.addItem}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className={styles.itemTitle}>{utility.displayName}</div>
        <MdArrowDropDown
          onClick={handleToggle}
          className={open ? `${styles.arrowUp} ${styles.arrow}` : styles.arrow}
        />
      </div>
      <div className={open ? styles.itemDescription : styles.closed}>
        {utility.description}
      </div>
    </div>
  );
};
